/**
 * @param {Element} parentContainer - the element from where you want to start searching for the targetClassNames
 * @param {String} targetClassName - String of classname
 */

export default function (parentContainer, targetClassName) {
    const items = parentContainer.querySelectorAll(`.${targetClassName}`)
    return Array.from(items).filter((item) => item.checkVisibility())
}
